var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useEffect } from 'react';
import { coreFromSettings, sameColors, settingsFromCore } from '../theme/config';
import { setCommunityTheme, wearTheme } from '../theme/root';
import { withDone } from '@rad/utility/http';
import { getThemeSettings, updateThemeSettings } from '../common/network/district';
import { useToast } from '../contexts/toast';
// The Theme page's colors: what the community has saved, and the draft being picked. The whole page
// wears the draft while it is open, so the previews and the admin around them follow every pick, and
// leaving takes it off again. Null until the saved colors are in.
export const useThemeConfig = () => {
    const toast = useToast();
    const [saved, setSaved] = useState(null);
    const [draft, setDraft] = useState(null);
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        withDone(getThemeSettings())().then((settings) => {
            const colors = coreFromSettings(settings !== null && settings !== void 0 ? settings : []);
            setSaved(colors);
            setDraft(colors);
        });
    }, []);
    useEffect(() => draft === null ? undefined : wearTheme(draft), [draft]);
    const save = () => __awaiter(void 0, void 0, void 0, function* () {
        if (draft === null)
            return;
        setSaving(true);
        const [ok] = yield updateThemeSettings(settingsFromCore(draft)).finally(() => setSaving(false));
        if (!ok) {
            toast.error('The theme could not be saved');
            return;
        }
        setCommunityTheme(draft);
        setSaved(draft);
        toast.success('Theme saved');
    });
    return {
        draft,
        setDraft,
        dirty: draft !== null && saved !== null && !sameColors(draft, saved),
        undo: () => setDraft(saved),
        save,
        saving,
    };
};
export default useThemeConfig;
